import useMeasure from 'react-use-measure';
import { ResizeObserver } from '@juggle/resize-observer';

import { LegendPosition } from '../models';

type UseResponsiveChartReturn = {
    containerRef: (element: HTMLDivElement | null) => void;
    width: number;
    height: number;
    legendDimensions: { w: number; h: number };
};

type Dimensions = { width: number; height: number };
type GetLegendDimensions = (dimensions: Dimensions) => Dimensions;

const computeLegendDimensions: Record<LegendPosition, GetLegendDimensions> = {
    top: ({ width }) => ({ width, height: 32 }),
    bottom: ({ width }) => ({ width, height: 32 }),
    left: ({ height, width }) => ({ width: width < 385 ? 0 : 140, height }),
    right: ({ height, width }) => ({ width: width < 385 ? 0 : 140, height }),
    none: () => ({ width: 0, height: 0 }),
};

const useResponsiveChart = (
    legendPosition: 'top' | 'bottom' | 'left' | 'right' | 'none' = 'none',
): UseResponsiveChartReturn => {
    const [containerRef, { width, height }] = useMeasure({ debounce: 100, polyfill: ResizeObserver });
    const legendDimensions = computeLegendDimensions[legendPosition]({ width, height });
    return {
        containerRef,
        width,
        height,
        legendDimensions: { w: legendDimensions.width, h: legendDimensions.height },
    };
};

export { useResponsiveChart };
